import React from "react";
import qr_yape from "../../assets/qr_yape.png";
import qr_plin from "../../assets/qr_plin.png";

export const FormCampista = ({ form, handleChange }) => (
  <div className="row">
    <div className="col-12">
      <div
        className="p-4 rounded-4 shadow-sm"
        style={{
          background: "linear-gradient(135deg,#eef4ff,#ffffff)",
          border: "3px solid rgba(13,110,253,0.2)",
        }}
      >
        <h5
          className="fw-bold"
          style={{
            color: "#0d6efd",
          }}
        >
          Información para Miembros de Equipo
        </h5>

        <p className="mb-0 text-muted fs-5">
          Participa de las 3 etapas del Programa Misionero, Entrenamiento
          (11dias), Proyecto o viaje (20dias), Reporte (3dias) Edades: 13-21
          años.
        </p>
      </div>
    </div>

    <div className="col-md-6 mb-3">
      <br></br>
      <label className="form-label fw-semibold">Primer Nombre</label>

      <input
        type="text"
        className="form-control form-control-lg rounded-4"
        name="nombre"
        value={form.nombre}
        onChange={handleChange}
        required
      />
    </div>

    <div className="col-md-6 mb-3">
      <br></br>
      <label className="form-label fw-semibold">Apellido Paterno</label>

      <input
        type="text"
        className="form-control form-control-lg rounded-4"
        name="apellido"
        value={form.apellido}
        onChange={handleChange}
        required
      />
    </div>

    <div className="col-md-6 mb-3">
      <label className="form-label fw-semibold">Celular</label>

      <input
        type="text"
        className="form-control form-control-lg rounded-4"
        name="celular"
        value={form.celular}
        onChange={handleChange}
        required
      />
    </div>

    <div className="col-md-6 mb-3">
      <label className="form-label fw-semibold">Tipo de Celular</label>

      <select
        className="form-select form-select-lg rounded-4"
        name="tipo_celular"
        value={form.tipo_celular}
        onChange={handleChange}
        required
      >
        <option value="">Tipo</option>

        <option>Personal</option>
        <option>Apoderado</option>
      </select>
    </div>
    <div className="col-md-6 mb-3">
      <label className="form-label fw-semibold">DNI / Pasaporte</label>

      <input
        type="text"
        className="form-control form-control-lg rounded-4"
        name="documento"
        value={form.documento}
        onChange={handleChange}
        required
      />
    </div>

    <div className="col-md-6 mb-3">
      <label className="form-label fw-semibold">País</label>

      <input
        type="text"
        className="form-control form-control-lg rounded-4"
        name="pais"
        value={form.pais}
        onChange={handleChange}
        required
      />
    </div>

    <div className="col-md-6 mb-3">
      <label className="form-label fw-semibold">Región/Ciudad</label>

      <input
        type="text"
        className="form-control form-control-lg rounded-4"
        name="departamento"
        value={form.departamento}
        onChange={handleChange}
        required
      />
    </div>

    <div className="col-md-6 mb-3">
      <label className="form-label fw-semibold">Iglesia</label>

      <input
        type="text"
        className="form-control form-control-lg rounded-4"
        name="iglesia"
        value={form.iglesia}
        onChange={handleChange}
        required
      />
    </div>

    <div className="col-md-6 mb-3">
      <label className="form-label fw-semibold">Edad</label>

      <input
        type="number"
        className="form-control form-control-lg rounded-4"
        name="edad"
        value={form.edad}
        onChange={handleChange}
        required
      />
    </div>

    <div className="col-12 mb-4">
      <label className="form-label fw-semibold">Proyecto Misionero</label>

      <select
        className="form-select form-select-lg rounded-4"
        name="proyecto"
        value={form.proyecto}
        onChange={handleChange}
        required
      >
        <option value="">Seleccione un proyecto</option>

        <option>Tumbes</option>
        <option>Tacna</option>
        <option>Puno</option>
        <option>Arequipa</option>
      </select>
    </div>
  </div>
);
